import * as yup from 'yup';

export const stationaerOptionenSchema = yup.object({
  leistung: yup.string().default(''),
  gebuehrenordnung: yup.string().default(''),
});
